export default "__VITE_ASSET__BeUkiyHn__"